export default __webpack_public_path__ + "static/media/threeTomoea.193ebfe1.png";